import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["handle"]
  static outlets = ["modal-trade"]
  static values = {
    closeThreshold: { type: Number, default: 150 },
    springBack: { type: Number, default: 0.5 }
  }

  connect() {
    this.isDragging = false
    this.startY = 0
    this.currentY = 0

    // Add touch event listeners
    this.element.addEventListener('touchstart', this.dragStart, { passive: false })
    this.element.addEventListener('touchmove', this.dragMove, { passive: false })
    this.element.addEventListener('touchend', this.dragEnd)

    // Add mouse event listeners for desktop testing
    this.element.addEventListener('mousedown', this.dragStart)
    window.addEventListener('mousemove', this.dragMove)
    window.addEventListener('mouseup', this.dragEnd)
  }

  disconnect() {
    this.element.removeEventListener('touchstart', this.dragStart)
    this.element.removeEventListener('touchmove', this.dragMove)
    this.element.removeEventListener('touchend', this.dragEnd)

    this.element.removeEventListener('mousedown', this.dragStart)
    window.removeEventListener('mousemove', this.dragMove)
    window.removeEventListener('mouseup', this.dragEnd)
  }

  dragStart = (e) => {
    // Only handle drag from the handle target
    if (!this.handleTargets.some(handle => handle.contains(e.target))) return

    this.isDragging = true
    this.startY = e.type === 'mousedown' ? e.clientY : e.touches[0].clientY
    this.currentY = this.startY

    e.preventDefault()
  }

  dragMove = (e) => {
    if (!this.isDragging) return

    const clientY = e.type === 'mousemove' ? e.clientY : e.touches[0].clientY
    const deltaY = clientY - this.startY

    // Only allow downward drag
    if (deltaY < 0) return

    this.currentY = clientY

    // Calculate opacity based on drag distance
    const opacity = Math.max(0, 1 - (deltaY / this.closeThresholdValue))

    this.element.style.transform = `translateY(${deltaY}px)`
    this.element.style.opacity = opacity

    e.preventDefault()
  }

  dragEnd = () => {
    if (!this.isDragging) return

    this.isDragging = false
    const deltaY = this.currentY - this.startY

    if (deltaY > this.closeThresholdValue) {
      this.modalTradeOutlet.closeModal()
    } else {
      // Spring back animation
      this.element.style.transition = `transform ${this.springBackValue}s ease-out, opacity ${this.springBackValue}s ease-out`
      this.element.style.transform = 'translateY(0)'
      this.element.style.opacity = '1'

      // Remove transition after animation
      setTimeout(() => {
        this.element.style.transition = ''
      }, this.springBackValue * 1000)
    }
  }
}
